import { createContext, useContext } from 'react'
import {
  DEFAULT_LANGUAGE,
  isLiveLanguage,
  type SupportedLanguage,
} from './supported-languages'

export type AppLanguage = SupportedLanguage

export function resolveLanguage(raw: unknown): AppLanguage {
  return isLiveLanguage(raw) ? raw : DEFAULT_LANGUAGE
}

interface LanguageContextValue {
  language: AppLanguage
  setLanguage: (lang: AppLanguage) => void
}

export const LanguageContext = createContext<LanguageContextValue>({
  language: DEFAULT_LANGUAGE,
  setLanguage: () => null,
})

export function useLanguage(): LanguageContextValue {
  return useContext(LanguageContext)
}
